import { render, staticRenderFns } from "./LegalEntityMonitoringSetup.vue?vue&type=template&id=17f1504b&scoped=true"
import script from "./LegalEntityMonitoringSetup.vue?vue&type=script&lang=js"
export * from "./LegalEntityMonitoringSetup.vue?vue&type=script&lang=js"
import style0 from "./LegalEntityMonitoringSetup.vue?vue&type=style&index=0&id=17f1504b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f1504b",
  null
  
)

export default component.exports